import { AxiosResponse } from 'axios';
import { HttpMethod } from '../utils/enums/http-method.enum';
import { RequestClientInterfaceService } from './request-client.interface.service';
import {
    COGNITO_TOKEN_NAME,
    DEALER_PORTAL_URL,
    PERMISSIONS_TOKEN_NAME,
} from '../config';

export interface ISettingsItem {
    keyName: string;
    keyValue: string;
}

interface IGetSettingsResponse {
    settings?: ISettingsItem[];
}

/**
 * Service responsible for Date & Term settings operations.
 */
export class DateTermSettingsService {
    private readonly dealerPortalUrlStructure = `${DEALER_PORTAL_URL}`;
    private client: RequestClientInterfaceService;
    private headers = {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: '',
    };

    constructor() {
        this.client = new RequestClientInterfaceService();
    }

    public async saveSettings(
        settings: ISettingsItem[],
    ): Promise<AxiosResponse> {
        const url = `${this.dealerPortalUrlStructure}/saveSettings`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                settings,
                jwtToken: permissionsToken,
            },
        };

        return this.client.sendRequest(request);
    }

    public async getSettings(
        keyNames: string[],
    ): Promise<AxiosResponse<IGetSettingsResponse>> {
        const url = `${this.dealerPortalUrlStructure}/getSettings`;
        const cognitoToken = window.sessionStorage.getItem(COGNITO_TOKEN_NAME);
        const permissionsToken = window.sessionStorage.getItem(
            PERMISSIONS_TOKEN_NAME,
        );

        const request = {
            method: HttpMethod.post,
            url,
            headers: {
                ...this.headers,
                Authorization: `Bearer ${cognitoToken}`,
            },
            data: {
                keyNames,
                jwtToken: permissionsToken,
            },
        };

        return this.client.sendRequest(request);
    }
}
